module.exports = __webpack_public_path__ + "static/media/zam5.f4a7b40c.jpg";